import Revenue from './Revenue';

const History = () => {
    return <Revenue />;
};

export default History;
